import { Administrator } from "resource-planner-model";
import env from "../app/Environment";
import fetchService from "../utils/FetchService";
import { PersistAdministratorResult } from "./AdministratorTypes";

export class AdministratorService {
  constructor(private endpoint: string) {}

  async fetch(): Promise<Administrator[]> {
    return fetchService
      .fetch(`${this.endpoint}/administrators`, {})
      .then((r) => r.json())
      .catch((): any[] => []);
  }

  async delete(email: string): Promise<Administrator[]> {
    return fetchService
      .fetch(`${this.endpoint}/administrators/${email}`, {
        method: "DELETE",
      })
      .then((r) => r.json());
  }

  async persist(item: Administrator): Promise<PersistAdministratorResult> {
    return fetchService
      .fetch(`${this.endpoint}/administrators`, {
        method: "POST",
        body: JSON.stringify(item),
      })
      .then((r) => r.json());
  }
}

const service = new AdministratorService(env.endpoint);

export default service;
